module.exports = "/img/_/_/_/assets/images/creeper/battle/uncommon//14.jpg?6af00447a8c04c900c363dda960330b7";